export enum PlayerView {
  LIST = 1,
  EDIT = 2,
}
